"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Folder = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_intersection_observer_1 = require("react-intersection-observer");
const ProgressiveImage_1 = __importDefault(require("../../../common/components/Other/ProgressiveImage"));
const FolderWrapper = styled_components_1.default.div `
  display: flex;
  position: relative;
  padding: 3px;
  margin-bottom: 1.58vmin;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  padding: 5px;
  cursor: pointer;
`;
const FolderImageContainer = styled_components_1.default.div `
  flex-basis: unset;

  .progressive-image {
    height: 120px;
    width: 120px;
    flex-shrink: 0;
    border-radius: 7px;
    @media (max-width: 480px) {
      height: 100px;
      width: 100px;
    }
  }

  @media (max-width: 480px) {
    height: 100px;
    width: 100px;
  }
`;
const ImagePlaceholder = styled_components_1.default.div `
  background: linear-gradient(
    12deg,
    ${(props) => props.theme.palette.mainAppColor.dark} 5%,
    ${(props) => props.theme.palette.mainAppColor.light} 25%,
    ${(props) => props.theme.palette.mainAppColor.main} 100%
  );
  height: 120px;
  width: 120px;
  border-radius: 7px;
  @media (max-width: 480px) {
    height: 100px;
    width: 100px;
  }
`;
const FolderTitle = styled_components_1.default.div `
  margin-left: 10px;
  flex-grow: 1;
  font-size: 1rem;
  display: flex;
  align-items: center;
`;
const Folder = (props) => {
    const [isVisible, setIsVisible] = (0, react_1.useState)(false);
    const { folderData, onFolderClick } = props;
    const handleFolderClick = () => {
        onFolderClick(folderData);
    };
    const showType = window.location.search.includes("dev-mode=true");
    return (
    // @ts-ignore
    react_1.default.createElement(react_intersection_observer_1.InView // CHECKs
    , { triggerOnce: true, as: "div", onChange: (inView, entry) => {
            if (inView) {
                setIsVisible(true);
            }
        } },
        react_1.default.createElement(FolderWrapper, { onClick: handleFolderClick }, isVisible && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(FolderImageContainer, null, folderData.smallImage ? (react_1.default.createElement(ProgressiveImage_1.default, { image: folderData.smallImage
                    ? folderData.smallImage
                    : "/images/other/placeholder.png", alt: "Folder thumbnail", imageClass: "progressive-image" })) : (react_1.default.createElement(ImagePlaceholder, null))),
            react_1.default.createElement(FolderTitle, null, `${folderData.title} ${showType ? "-Folder" : ""} `))))));
};
exports.Folder = Folder;
